import React from "react";
import "./ViewSwitch.scss";
import { Segmented } from "antd";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";

// Cards or rows for a list of products. The titles are what a screen reader
// and the hover tooltip say, the options themselves are icons only.
export default function ViewSwitch({ view, onChange, size = "large" }) {
  return (
    <Segmented
      className="viewSwitch"
      size={size}
      value={view === "list" ? "list" : "grid"}
      onChange={onChange}
      options={[
        {
          value: "grid",
          icon: <AppstoreOutlined />,
          title: "Card view",
        },
        {
          value: "list",
          icon: <UnorderedListOutlined />,
          title: "List view",
        },
      ]}
    />
  );
}
